import * as Yup from "yup";

const AddPolicySchema = Yup.object().shape({
  policy_name: Yup.string().required("Policy name is required"),
  description: Yup.string().required("Description is required"),
});

export default AddPolicySchema;
